export const getScreenWidth = () => window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
